import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import communityGardenSeedlingListAction from './communityGardenSeedlingList.action.json' with { type: 'json' }
import { communityGardenSeedlingObject } from '../../communityGardenSeedlingObject'

export const communityGardenSeedlingExpression = expression(communityGardenSeedlingObject.shape)

const communityGardenSeedlingListDefinition = defineAction({
  ...communityGardenSeedlingListAction,

  input: z.object({
    filter: communityGardenSeedlingExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      type: 'Tipo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({ items: z.array(communityGardenSeedlingObject), count: z.number() }),
})

export default communityGardenSeedlingListDefinition
